<div class="main-customer-post-div" #usersListDiv>
    <div class="usersListDiv">
        <!-- Main Category View -->
        <!-- Main Category View -->
        <!-- Main Category View -->
        <!-- Main Category View -->
        <div *ngIf="currentView === 'main'">
            <div class="row pad10T">
                <div class="col-md-7 pad15T bus_lablel_mob">
                    <strong><span> Business Category:</span>
                        <div style="display: inline-block; margin-left: 5px;">
                            <label>
                                <input type="radio" name="categoryType" [(ngModel)]="selectedCategoryType"
                                    value="Service" (change)="onCategoryTypeChange('Service')" checked>
                                Service Provider
                            </label>
                            <label style="margin-left: 10px;">
                                <input type="radio" name="categoryType" [(ngModel)]="selectedCategoryType"
                                    value="Supplier" (change)="onCategoryTypeChange('Supplier')">
                                Supplier
                            </label>
                        </div>
                    </strong>
                </div>
                <!-- component.html -->
                <div class="col-md-5">
                    <div class="searchbtnDiv">
                        <input placeholder="Search Category" type="text" [(ngModel)]="searchText"
                            (blur)="searchCategories()" class="form-control txt-search" />
                        <button type="button" class="btn btn_search" (click)="searchCategories()">Search</button>
                    </div>
                </div>

            </div>
            <div class="clearfix mrg25B"></div>
            <div class="grid-container">
                <div class="card categoryDiv border border-secondary"
                    [ngClass]="{'bg-selected': selectedCategory === category.ParentCategory}"
                    *ngFor="let category of filteredCategoryList" (click)="LoadSubCategory(category.ParentCategory)">
                    <i [class]="category.icon"></i>
                    <span class="category-label">{{ category?.ParentCategory }}</span>
                </div>
            </div>

            <br /><br />
        </div>




        <!-- Sub Category View -->
        <div *ngIf="currentView === 'sub'">
            <fieldset>
                <legend>
                    Business Sub Category:
                    <button class="back-button" (click)="goBack()">Back to Categories</button>
                </legend>
                <div class="grid-container">
                    <div class="card categoryDiv border border-secondary"
                        [ngClass]="{'bg-selected': CategoryID == subCat.CategoryID}"
                        *ngFor="let subCat of SubCategoryList" (click)="LoadBusinessPartnerList(subCat.CategoryID)">
                        <i class="fas fa-sitemap"></i>
                        <span class="category-label">{{ subCat?.Category }}</span>
                    </div>
                </div>
            </fieldset>
            <br /><br />
        </div>

        <!-- Business Partners View -->
        <div *ngIf="currentView === 'partners'">
            <fieldset class="partners-fieldset">
                <legend>
                    Business Partners:
                    <button class="back-button" (click)="goBack()">Back to Main</button>
                </legend>
                <div class="row">
                    <div class="col-md-6" *ngFor="let user of filteredPartnersList">
                        <div class="carbon-example flex-wrapper pad15A">
                            <div class="image-wrapper pad10T">
                                <img [src]="user?.UserProfile" onerror="this.src='assets/images/customer_images.jpg'"
                                    alt="example design logo" class="partner-img">
                                <div class="buttons-wrapper">
                                    <button type="button" (click)="doContactAgent('Call', user)"
                                        class="btn btn-primary">
                                        <i class="fas fa-phone"></i>
                                    </button>
                                    <button type="button" (click)="doContactAgent('Message', user)"
                                        class="btn btn-primary">
                                        <i class="fa fa-envelope" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" (click)="showVideoModal(user.UserID)" class="btn btn-danger">
                                        <i class="fab fa-youtube" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="inner-wrapper">
                                <p class="partner-name">{{ user?.Partner_Name }}</p>
                                <table width="100%" border="0" cellspacing="0" cellpadding="0" class="table_cls">
                                    <tr>
                                        <td width="30"><i class="fa fa-map-marker-alt icon"></i></td>
                                        <td>{{ user?.User_Address }}</td>
                                    </tr>
                                    <tr>
                                        <td width="30"><i class="fa fa-building icon"></i></td>
                                        <td>{{ user?.CompanyName }}</td>
                                    </tr>
                                    <tr>
                                        <td width="30"><i class="fa fa-map icon"></i></td>
                                        <td>{{ user?.AREAS_JSON }}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-briefcase icon"></i> </td>
                                        <td>{{ user?.Business_Category }}</td>
                                    </tr>
                                </table>

                                <div class="business-category-wrapper">
                                    <p></p>
                                </div>
                                <div *ngIf="user?.Profile_Description?.length > 0" class="business-category-wrapper">
                                    <p><i class="fa fa-info-circle icon"></i>
                                        <ng-container *ngIf="!user.showMore">
                                            {{ user?.Profile_Description | slice:0:50 }}
                                            <span *ngIf="user?.Profile_Description?.length > 50">
                                                ... <a href="javascript:void(0)"
                                                    (click)="user.showMore = !user.showMore"><strong>{{ 'More'
                                                        }}</strong></a>
                                            </span>
                                        </ng-container>
                                        <ng-container *ngIf="user.showMore">
                                            {{ user?.Profile_Description }}
                                            <a href="javascript:void(0)"
                                                (click)="user.showMore = !user.showMore"><strong>{{
                                                    'Less' }}</strong></a>
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            <br /><br />
        </div>

        <!-- Modal Structure -->
        <div class="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="videoModalLabel">Video</h5>
                        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <video width="100%" controls [src]="videoUrl">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>